export default {
    namespaced: true,
    state: {
        brands: [],
        activeBrand: -1, //-1 not active
        errors: {
            brands: {},
            deleteBrand: {},
            updateBrand: {},
            createBrand: {}
        }
    },
    getters: {
        getActiveBrand(state) {
            if (state.activeBrand <= 0) return null
            return state.brands.find(item => item.BrandID === state.activeBrand)
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        SET_BRANDS(state, payload) {
            state.brands = payload
        },
        SET_ACTIVE_BRAND(state, id) {
            state.activeBrand = id
        }
    },
    actions: {
        async getBrands({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'brands',
                val: ''
            })

            const url = '/supplier/brands'

            try {
                const resp = await this.$axios.get(url, {
                    params: data
                })
                commit('SET_BRANDS', resp.data)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'brands',
                        val: e.response.data
                    })
                }
            }
        },
        async createBrand({ commit, dispatch }, data) {
            commit('SET_ERRORS', {
                key: 'createBrand',
                val: {}
            })

            const url = '/supplier/brands'

            try {
                const resp = await this.$axios.post(url, data)
                commit('SET_ACTIVE_BRAND', resp.data.BrandID)
                dispatch('getBrands')
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'createBrand',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'createBrand',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        async updateBrand({ commit, dispatch }, data) {
            commit('SET_ERRORS', {
                key: 'updateBrand',
                val: ''
            })

            const url = `/supplier/brands/${data.BrandID}`

            try {
                const resp = await this.$axios.patch(url, data)

                dispatch('getBrands')
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'updateBrand',
                        val: e.response.data
                    })
                }
            }
        },
        async deleteBrand({ commit, dispatch }, payload) {
            commit('SET_ERRORS', {
                key: 'deleteBrand',
                val: ''
            })

            const url = `/supplier/brands/${payload.brandId}`

            try {
                const resp = await this.$axios.delete(url, {
                    data: payload.data
                })
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'deleteBrand',
                        val: e.response.data
                    })
                }

                throw e
            }
        }
    }
}
